<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel header="{{'label.search' | translate }}" [toggleable]="true" [collapsed]="panelCollapsed"
      expandIcon="pi pi-angle-double-up" collapseIcon="pi pi-angle-double-down">
      <div class="card" #contentElement pBPaaSFocusTrap>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('ouId')" class="bpaas-required">Corp No.</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="ouSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchOuSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')" (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)" (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')" dataKey="value" appendTo="body"
              formControlName="ouId" [inputId]="parseToId('ouId')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('ouId')">
              <small class="p-error" *ngIf="formControl('ouId').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-5 lg:col-5">
            <label class="bpaas-required">Data YM: Input Format (yyyyMM) ex.202601</label>
            <div class="grid p-fluid" style="margin: 0;">
              <div class="col-5" style="padding: 0;">
                <input type="text" pInputText formControlName="startDate" [id]="parseToId('startDate')"
                  maxlength="6" placeholder="yyyyMM" />
                <small class="p-error" *ngIf="formControl('startDate').errors?.['format']">
                  {{ 'message.validation.begin-month-format' | translate }}
                </small>
                <small class="p-error" *ngIf="formControl('startDate').errors?.['dateRange']">
                  {{ 'message.validation.begin-month-less-end-month' | translate }}
                </small>
                <div *ngIf="formControlInvalid('startDate')">
                  <small class="p-error" *ngIf="formControl('startDate').errors?.['required']">
                    {{ 'message.validation.required' | translate }}
                  </small>
                </div>
              </div>
              <div class="col-2 flex align-items-center justify-content-center" style="padding: 0;">
                <label style="margin: 0;">To</label>
              </div>
              <div class="col-5" style="padding: 0;">
                <input type="text" pInputText formControlName="endDate" [id]="parseToId('endDate')"
                  maxlength="6" placeholder="yyyyMM" />
                <small class="p-error" *ngIf="formControl('endDate').errors?.['format']">
                  {{ 'message.validation.end-month-format' | translate }}
                </small>
                <div *ngIf="formControlInvalid('endDate')">
                  <small class="p-error" *ngIf="formControl('endDate').errors?.['required']">
                    {{ 'message.validation.required' | translate }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('itemNumber')" class="bpaas-required">{{ 'field.item-number' | translate }}</label>
            <p-autoComplete *ngIf="langChangeVisible" [suggestions]="itemSuggestions" [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true" [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}" (completeMethod)="searchItemSuggestions($event)"
              (onClear)="onItemClear()" (onFocus)="autoCompleteFocus($event)" (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)" (onSelect)="onItemSelect($event)" dataKey="value" appendTo="body"
              formControlName="itemNumber" [inputId]="parseToId('itemNumber')" field="label">
            </p-autoComplete>
            <div *ngIf="formControlInvalid('itemNumber')">
              <small class="p-error" *ngIf="formControl('itemNumber').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6">
            <label [for]="parseToId('itemDesc')">{{ 'field.item-desc' | translate }}</label>
            <input type="text" pInputText formControlName="itemDesc" [id]="parseToId('itemDesc')" readonly />
          </div>
        </div>
        <div class="grid p-fluid justify-content-end bpaas-button-row">
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.reset' | translate }}" class="p-button-outlined mr-2"
              (click)="searchReset();onItemClear();" [id]="parseToId('btnReset')"></button>
          </div>
          <div class="col-12 md:col-3 lg:col-2">
            <button type="button" pButton label="{{ 'button.query' | translate }}" (click)="query()"
              [id]="parseToId('btnQuery')"></button>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>

<!-- Total Qty / Total Amt -->
<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <div class="grid p-fluid">
      <div class="col-12 md:col-3 lg:col-3">
        <label>Total Qty</label>
        <input type="text" pInputText [value]="totalQty | number" readonly />
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <label>Total Amt</label>
        <input type="text" pInputText [value]="totalAmt | number" readonly />
      </div>
    </div>
  </p-panel>
</div>

<!-- Query Results -->
<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <span *ngIf="queryId">{{ 'field.query-id' | translate }} : {{queryId}}</span>

    <p-table #tableComponent [value]="detailDatas" styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped"
      [selectionMode]="tableSelectionMode" [(selection)]="rowSelectedDatas" [dataKey]="rowDataKeyName"
      [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'table.paginator' | translate: {'first': '{first}', 'last': '{last}', 'totalRecords': '{totalRecords}' } }}"
      [rowsPerPageOptions]="[10, 20, 50]" [paginatorDropdownAppendTo]="'body'" scrollHeight="75vh" [scrollable]="true"
      [resizableColumns]="true" columnResizeMode="expand" [columns]="selectedColumns"
      [detailInViewStatus]="detailInViewStatus()" (onStateSave)="onDetailTableStateSave($event)"
      (onFilter)="onDetailTableFilter($event)" (onColResize)="onColResize($event)">
      <ng-template pTemplate="header" let-columns>
        <tr id="bpaas-table-header">
          <th *ngFor="let column of columns" [pSortableColumn]="column.sortable ? column.field : ''"
            [pSortableColumnDisabled]="column.sortable ? false : true" pResizableColumn>
            <label>{{ column.header | translate }}</label>
            <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr [id]="parseToId('rowData-' + rowIndex)">
          <td *ngFor="let column of tableColumns" [class.bpaas-align-right]="column.numberField || column.alignRight"
            [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
            <ng-container *ngIf="column.numberField">
              {{ (rowData[column.field] ?? 0) | dynamicDecimal }}
            </ng-container>
            <ng-container *ngIf="!column.numberField">
              {{ rowData[column.field] }}
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="tableColumns.length">
            {{ 'table.no-records-found' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>
